<!-- @veltra/icons generated sha256:0d4f476421108800 gen:8 source:src/svg/normal/user-clear.svg -->
<script setup lang="ts">
defineOptions({ name: 'UserClear' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="m11.763 13.934 1.232-1.232-1.232-1.232a.51.51 0 0 1-.003-.715.51.51 0 0 1 .71.008l1.232 1.232 1.232-1.232a.51.51 0 0 1 .715-.003c.19.19.188.514-.008.71l-1.232 1.232 1.232 1.232a.51.51 0 0 1 .003.715.51.51 0 0 1-.71-.008l-1.232-1.232-1.232 1.232a.51.51 0 0 1-.715.003.51.51 0 0 1 .008-.71M8 8.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m0-1a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5m1.904 3.141A12.84 12.84 0 0 0 2.5 11.74v1.76h7.49c.277 0 .51.228.51.504a.495.495 0 0 1-.492.496H2a.5.5 0 0 1-.5-.5v-2.275a.96.96 0 0 1 .537-.872 13.8 13.8 0 0 1 8.06-1.194.48.48 0 0 1 .403.478v.008a.512.512 0 0 1-.596.496"
    />
  </svg>
</template>
